import { Loader } from '@Core/Components/Loader/Loader'
import { loginTestID } from './Login.constants'
import { MicrosoftButton } from './Login.styles'

interface Props {
    onClick: () => void
    loading?: boolean
}

const MicrosoftLogo = () => (
    <svg width="20" height="20" viewBox="0 0 21 21" aria-hidden="true">
        <rect x="1" y="1" width="9" height="9" fill="#f25022" />
        <rect x="11" y="1" width="9" height="9" fill="#7fba00" />
        <rect x="1" y="11" width="9" height="9" fill="#00a4ef" />
        <rect x="11" y="11" width="9" height="9" fill="#ffb900" />
    </svg>
)

export const MicrosoftLoginButton = ({ onClick, loading }: Props) => {
    if (loading) return <Loader />
    return (
        <MicrosoftButton data-testid={loginTestID.button} type="button" onClick={onClick}>
            <MicrosoftLogo />
            Entrar com Microsoft
        </MicrosoftButton>
    )
}
